import { useMutation } from '@tanstack/react-query';

import Client from './client';

import type { UseMutationOptions } from '@tanstack/react-query';

export const useUserMeUpdate = (
  options: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof Client.updateUserMe>>,
      Error,
      Parameters<typeof Client.updateUserMe>[0],
      unknown
    >,
    'mutationFn'
  > = {},
) => {
  const { mutateAsync, status, mutate } = useMutation({
    mutationFn: Client.updateUserMe,
    ...options,
  });

  return {
    updateUserMeMutateAsync: mutateAsync,
    updateUserMeMutate: mutate,
    updateUserMeStatus: status,
  };
};
